import type { Content as ContentType } from '../../../types/capi/content';
import ContentImage from './ContentImage';
import Embed from './Embed';
import Header from './Header';
import LegacyHtml from './LegacyHtml';
import Links from './Links';
import List from './List';
import Paragraphs from './Paragraphs';
import ProductBlock from './ProductBlock';
import Quote from './Quote';
import Video from './Video';

type Props = {
  collapsibleParagraphs?: boolean;
  constrainTextWidth?: boolean;
  content: ContentType[];
};

export const Constrainable = ({
  children,
  constrain
}: {
  children: React.ReactNode;
  constrain: boolean;
}) => {
  const constrainedStyle = 'mx-auto self-start px-4 lg:w-2/3 lg:px-0';

  return (
    <div className={`w-full ${constrain ? constrainedStyle : ''}`}>
      {children}
    </div>
  );
};

const Content = ({
  content,
  constrainTextWidth = false,
  collapsibleParagraphs = false
}: Props) => {
  return (
    <div className="flex w-full flex-col items-center gap-5">
      {content.map((item, index) => {
        switch (item.type) {
          case 'paragraphs':
            return (
              <Constrainable constrain={constrainTextWidth} key={`p-${index}`}>
                <Paragraphs
                  collapsible={collapsibleParagraphs}
                  paragraphs={item}
                />
              </Constrainable>
            );
          case 'quote':
            return <Quote key={`quote-${index}`} quote={item} />;
          case 'dynamic_product_block':
            return <ProductBlock.Dynamic key={`dpb-${index}`} dpb={item} />;
          case 'product_block':
            return <ProductBlock.Regular key={`rpb-${index}`} rpb={item} />;
          case 'header':
            return (
              <Constrainable
                constrain={constrainTextWidth}
                key={`header-${index}`}
              >
                <Header level={item.level}>{item.text}</Header>
              </Constrainable>
            );
          case 'legacy_html':
            return <LegacyHtml key={`lh-${index}`} item={item} />;
          case 'internal':
            return <Links.Internal key={`il-${index}`} link={item} />;
          case 'external':
            return <Links.External key={`el-${index}`} link={item} />;
          case 'list':
            return (
              <Constrainable
                constrain={constrainTextWidth}
                key={`list-${index}`}
              >
                <List list={item} />
              </Constrainable>
            );
          case 'video':
            return <Video key={`video-${index}`} video={item} />;
          case 'embed':
            return <Embed key={`embed-${index}`} embed={item} />;
          case 'image':
            return <ContentImage key={`img-${index}`} image={item} />;
          default:
            return null;
        }
      })}
    </div>
  );
};

export default Content;
